import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "plane",
  "use": "plane-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"plane\">\n<path d=\"M16.6562 0.15625C16.4062 0 16.125 -0.03125 15.875 0.125L1.375 8.375C1.125 8.5 0.96875 8.78125 1 9.0625C1 9.34375 1.1875 9.59375 1.4375 9.71875L6.21875 11.7188V15.25C6.21875 15.5312 6.375 15.7812 6.625 15.9375C6.75 16 6.875 16 6.96875 16C7.125 16 7.28125 15.9688 7.375 15.9062L10.875 13.6562L13.9375 14.9688C14.0312 15 14.125 15 14.25 15C14.375 15 14.5 14.9688 14.5938 14.9062C14.8125 14.8125 14.9375 14.5938 14.9688 14.375L16.9688 0.875C17.0312 0.59375 16.9062 0.3125 16.6562 0.15625ZM12.5312 3.75L6.65625 10.2812L3.4375 8.90625L12.5312 3.75ZM7.71875 13.9062V12.3438L9.1875 12.9688L7.71875 13.9062ZM13.625 13.1875L8.125 10.875L15.125 3.09375L13.625 13.1875Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/sharedComponents/Icon/images/plane.svg
// module id = US+q
// module chunks = 13